var _path, _rect, _mask, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSecureIcon = function SvgSecureIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#secure_icon_svg__a)",
    strokeWidth: 6,
    d: "M19 24c0-9.389 7.611-17 17-17s17 7.611 17 17v7H19z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 34,
    x: 11,
    y: 31,
    stroke: "url(#secure_icon_svg__b)",
    strokeWidth: 6,
    rx: 3
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "secure_icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 20,
    x: 18,
    y: 38,
    rx: 2
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 20,
    x: 18,
    y: 38,
    stroke: "url(#secure_icon_svg__c)",
    strokeWidth: 8,
    mask: "url(#secure_icon_svg__d)",
    rx: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "secure_icon_svg__a",
    x1: 36,
    x2: 36,
    y1: 4,
    y2: 34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "secure_icon_svg__b",
    x1: 36,
    x2: 36,
    y1: 28,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B9F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "secure_icon_svg__c",
    x1: 36,
    x2: 36,
    y1: 38,
    y2: 58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B9F7"
  })))));
};
export default SvgSecureIcon;